import React, { useState } from 'react';
import styles from './Step_Consultation.module.scss';
import InputField from '../ui/InputField/InputField';
import Button from '../ui/Button/Button';
import { createLead } from '../../api';

const StepConsultation = ({ onNextStep, quizData }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    comment: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (isFormValid) {
      const leadData = {
        ...formData,
        statusId: 3, // International consultation
        calculationResult: null,
        serviceName: "Міжнародна реєстрація ТМ (окрім ЄС)",
        serviceId: "id_9",
        gclid: quizData.gclid || null,
        host: window.location.host,
        classCount: null,
        classIds: null,
      };
      try {
        const data = await createLead(leadData);
        if (data.success) {
          // Fire Meta Pixel Lead event on successful form submission
          if (typeof window.fbq !== 'undefined') { window.fbq('track', 'Lead'); }
          onNextStep({ finalStep: "consultation" });
        } else {
          console.error("Lead creation failed:", data.message);
        }
      } catch (error) {
        console.error("Lead creation error:", error.message);
      }
    }
  };

  const isFormValid = formData.name && formData.email && formData.phone;

  return (
    <div className={styles.consultationContainer}>
      <p>Реєстрація за кордоном потребує індивідуального підходу. Залиште ваші дані, і наш експерт зв'яжеться з вами.</p>
      <div className={styles.form}>
        <InputField label="Ім'я" name="name" value={formData.name} onChange={handleChange} />
        <InputField label="Email" name="email" type="email" value={formData.email} onChange={handleChange} />
        <InputField label="Телефон" name="phone" type="tel" value={formData.phone} onChange={handleChange} />
        <InputField label="Коментар" name="comment" value={formData.comment} onChange={handleChange} isTextarea />
      </div>
      <Button onClick={handleSubmit} disabled={!isFormValid} primary>
        Підтвердити
      </Button>
    </div>
  );
};

export default StepConsultation;
